import { render, staticRenderFns } from "./AllRequests.vue?vue&type=template&id=e6c5ddc2&"
import script from "./AllRequests.vue?vue&type=script&lang=js&"
export * from "./AllRequests.vue?vue&type=script&lang=js&"
import style0 from "./AllRequests.vue?vue&type=style&index=0&id=e6c5ddc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports